export default "__VITE_ASSET__231a4b8a__"